import PublicHoliday from "@/views/menu/Sla/routes/PublicHoliday/PublicHoliday";
import SlaSeller from "@/views/menu/Sla/routes/SlaSeller/SlaSeller";

const slaRoutes = [
  {
    path: "public-holiday",
    name: "public-holiday",
    component: PublicHoliday,
  },
  {
    path: "sla-seller",
    name: "sla-seller",
    component: SlaSeller,
  },
];

export default slaRoutes;
